import { render, staticRenderFns } from "./HddsDialog.vue?vue&type=template&id=5c166e0b"
import script from "./HddsDialog.vue?vue&type=script&lang=js"
export * from "./HddsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports